import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpRequestService} from "../_common/http-request.service";

@Injectable()
export class CoinCandlestickConditionService {

    constructor(private http: HttpRequestService) {
    }

    getLineBot(): Observable<any[]> {
        return this.http.get(`line-bot-account/linebot`)
            .map(res => {
                return res.json()
            });
    }

    gets(parameters) {
        return this.http.get('coin-candlestick-condition/lists', parameters)
            .map(res => {
                return res.json();
            });
    }

    getConditions(dataRequest: any) {
        return this.http.get('coin-candlestick/conditions' + this.parseParamToString( dataRequest))
            .map(res => {
                return res.json();
            });
    }

    editCondition(dataRequest: any) {
        return this.http.put('coin-candlestick-condition/edit', dataRequest)
            .map(res => {
                return res.json();
            });
    }

    parseParamToString(param: any) {
        let queryString = `?`;
        for (var property in param) {
            if (param.hasOwnProperty(property)) {
                queryString += `&${property}=${param[property]}`;
            }
        }
        return queryString;
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/coin-candlestick-condition.service.ts